<ng-content select="p"></ng-content>
<form [formGroup]="tutorsForm" [dir]="textDirection">
  <ng-container formArrayName="emails">
    <div class="tutors-form__wrapper">
      <ng-container *ngFor="let item of tutorsEmails.controls; let i = index" [formGroupName]="i">
        <mat-form-field class="tutors-form__input">
          <mat-label>{{ 'user.tutors.email' | translate }} {{ i + 1 }}</mat-label>
          <input type="text" matInput formControlName="email" />
          <button
            mat-flat-button
            matSuffix
            class="add"
            (click)="addTutorEmail()"
            (keydown.enter)="addTutorEmail()"
            (keydown.space)="addTutorEmail()"
            tabindex="0"
            [attr.aria-label]="'general.add' | translate">
            <span class="odilo-icon" aria-hidden="true">add</span>
          </button>
          <button
            mat-flat-button
            matSuffix
            class="remove"
            *ngIf="tutorsEmails.controls.length > 1"
            (click)="deleteTutorEmail(i)"
            (keydown.enter)="deleteTutorEmail(i)"
            (keydown.space)="deleteTutorEmail(i)"
            tabindex="0"
            [attr.aria-label]="'general.remove' | translate">
            <span class="odilo-icon" aria-hidden="true">delete</span>
          </button>
        </mat-form-field>
      </ng-container>
    </div>
  </ng-container>

  <div class="tutors-form__actions">
    <button
      mat-flat-button
      (click)="submit()"
      (keydown.enter)="submit()"
      (keydown.space)="submit()"
      class="accent"
      disableRipple
      [disabled]="!tutorsForm.valid">
      {{ 'general.confirm' | translate }}
    </button>
    <button
      *ngIf="showReminder"
      mat-flat-button
      (click)="dismiss()"
      (keydown.enter)="dismiss()"
      (keydown.space)="dismiss()"
      class="accent transparent"
      disableRipple>
      {{ 'general.later' | translate }}
    </button>
  </div>
</form>
